import { css, cx } from "@emotion/css";
import { space, themeTokens, text } from "@octopusdeploy/design-system-tokens";
import type { ActionTemplateCategoryResource } from "@octopusdeploy/octopus-server-client";
import { ActionHandlerCategory } from "@octopusdeploy/octopus-server-client";
import React from "react";
import ExternalLink from "~/components/Navigation/ExternalLink/ExternalLink";
interface CategoryInfoProps {
    categories: ActionTemplateCategoryResource[];
    selectedCategory: ActionHandlerCategory | undefined;
}
const CategoryInfo = (props: CategoryInfoProps) => {
    const category = props.categories.find((x) => x.Id === props.selectedCategory);
    const getCategoryPageName = (selectedCategory: ActionHandlerCategory | undefined): string => {
        switch (selectedCategory) {
            case ActionHandlerCategory.Script:
                return "script-steps";
            case ActionHandlerCategory.Package:
                return "package-steps";
            case ActionHandlerCategory.Kubernetes:
                return "kubernetes-steps";
            case ActionHandlerCategory.Docker:
                return "docker-steps";
            case ActionHandlerCategory.Terraform:
                return "terraform-steps";
            case ActionHandlerCategory.Aws:
                return "aws-steps";
            case ActionHandlerCategory.Azure:
                return "azure-steps";
            case ActionHandlerCategory.GoogleCloud:
                return "google-cloud-steps";
            case ActionHandlerCategory.JavaAppServer:
                return "java-steps";
            case ActionHandlerCategory.WindowsServer:
                return "windows-steps";
            case ActionHandlerCategory.Certificate:
                return "cert-steps";
            case ActionHandlerCategory.Community:
                return "community-steps";
            case ActionHandlerCategory.StepTemplate:
                return "custom-steps";
            default:
                return "";
        }
    };
    const renderCategoryInfo = () => {
        switch (props.selectedCategory) {
            case ActionHandlerCategory.Featured: {
                return <p>Try a featured step template or filter by category</p>;
            }
            case ActionHandlerCategory.Community: {
                return (<p>
                        <ExternalLink href={getCategoryPageName(props.selectedCategory)}>Community step templates</ExternalLink>
                        {"  are contributed by the Octopus Community"}
                    </p>);
            }
            case ActionHandlerCategory.StepTemplate: {
                return (<p>
                        {"Learn about "}
                        <ExternalLink href={getCategoryPageName(props.selectedCategory)}>Custom step templates</ExternalLink>
                        {"  and "}
                        <ExternalLink href={getCategoryPageName(ActionHandlerCategory.Community)}>Community step templates</ExternalLink>
                    </p>);
            }
            case ActionHandlerCategory.Other: {
                return undefined;
            }
            default: {
                return (<p>
                        {"Learn about "}
                        <ExternalLink href={getCategoryPageName(props.selectedCategory)}>{category?.Name} steps</ExternalLink>
                    </p>);
            }
        }
    };
    return (<div className={cx(styles.container)}>
            <div className={cx(styles.title)}>{category?.Name}</div>
            <div className={cx(styles.details)}>{renderCategoryInfo()}</div>
        </div>);
};
export default CategoryInfo;
const styles = {
    container: css({
        padding: `${space[16]} ${space[16]} 0 ${space[16]}`,
    }),
    title: css({
        font: text.heading.large,
    }),
    details: css({
        color: themeTokens.color.text.secondary,
        font: text.regular.default.medium,
        p: {
            margin: 0,
        },
    }),
};
